import React from 'react';
import { Drawer } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const CommonDrawer = ({
  open,
  onClose,
  children,
  drawerId = 'drawer',
  anchor = 'right',
  hideBackdrop = true,
  sx = {},
  PaperProps = {},
  ModalProps = {},
  /** Use when stacking drawers (e.g. review + inline edit) so the top drawer receives pointer events */
  stackingZIndex,
  ...props
}) => {
  const theme = useTheme();
  const zIndex = stackingZIndex ?? theme.zIndex.drawer;
  const drawerRootSx = hideBackdrop ? { zIndex: 1099, width: 0, pointerEvents: 'none' } : { zIndex };
  const backdropSlotProps = hideBackdrop
    ? {
        backdrop: {
          sx: { pointerEvents: 'none', display: 'none' }
        }
      }
    : undefined;

  return (
    <Drawer
      anchor={anchor}
      open={open}
      onClose={onClose}
      hideBackdrop={hideBackdrop}
      id={drawerId}
      sx={drawerRootSx}
      ModalProps={{
        disableEscapeKeyDown: true,
        disableEnforceFocus: true,
        disableAutoFocus: true,
        disableScrollLock: true,
        keepMounted: false,
        ...(backdropSlotProps ? { slotProps: backdropSlotProps } : {}),
        ...ModalProps
      }}
      PaperProps={{
        ...PaperProps,
        sx: {
          width: { xs: 'calc(100vw - 20px)', md: 'calc(100vw - 290px)' },
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
          // --tsm-banner-offset: space taken by the Technical Support banner at the bottom (CESMB-8399).
          // maxHeight keeps drawers that pass their own height (e.g. 80vh/85vh) clear of it too.
          height: {
            xs: 'calc(100% - 75px - var(--tsm-banner-offset, 0px))',
            md: 'calc(100% - 80px - var(--tsm-banner-offset, 0px))'
          },
          maxHeight: {
            xs: 'calc(100% - 75px - var(--tsm-banner-offset, 0px))',
            md: 'calc(100% - 80px - var(--tsm-banner-offset, 0px))'
          },
          pointerEvents: 'auto',
          right: '10px',
          marginTop: { xs: '68px', md: '80px' },
          boxShadow: '0px 9px 20px 0px rgba(0, 0, 0, 0.10)',
          ...(PaperProps.sx || {}),
          ...(sx || {})
        }
      }}
      {...props}
    >
      {children}
    </Drawer>
  );
};

export default CommonDrawer;
